"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTemplateToTokenTypeAsset = exports.convertTemplateToChainAsset = exports.convertDatabaseAssetToTokenTypeAsset = exports.convertDatabaseAssetTokenIdToChainAsset = exports.convertDatabaseAssetToChainAsset = void 0;
const utils_1 = require("@dzambalaorg/utils");
const types_1 = require("@framework/types");
const convertDatabaseAssetToChainAsset = (components, options = {}) => {
    const { sortBy = "id" } = options;
    const { multiplier = 1 } = options;
    if (components === undefined) {
        throw new Error("blockchainError");
    }
    return components
        .slice()
        .sort((0, utils_1.comparator)(sortBy))
        .map(item => {
        let tokenId;
        if (item?.contract?.contractType === types_1.TokenType.NATIVE || item?.contract?.contractType === types_1.TokenType.ERC20) {
            tokenId = "0";
        }
        else if (item?.contract?.contractType === types_1.TokenType.ERC721 ||
            item?.contract?.contractType === types_1.TokenType.ERC998) {
            tokenId = (item.templateId || 0).toString();
        }
        else if (item?.contract?.contractType === types_1.TokenType.ERC1155) {
            tokenId = item.template?.tokens?.[0]?.tokenId;
            if (!tokenId) {
                // tokenId for ERC1155 notFound. You most likely forget to leftAndJoin Tokens for ERC1155
                throw new Error("blockchainError");
            }
        }
        else {
            throw new Error("blockchainError");
        }
        const [whole = "", decimals = ""] = multiplier.toString().split(".");
        const amount = ((BigInt(item.amount) * BigInt(`${whole}${decimals}`)) /
            10n ** BigInt(decimals.length)).toString();
        return {
            tokenType: Object.values(types_1.TokenType).indexOf(item.tokenType),
            token: item.contract.address,
            tokenId,
            amount,
        };
    });
};
exports.convertDatabaseAssetToChainAsset = convertDatabaseAssetToChainAsset;
// to get actual TokenID
const convertDatabaseAssetTokenIdToChainAsset = (components, options = {}) => {
    const { sortBy = "id" } = options;
    const { multiplier = 1 } = options;
    if (components === undefined) {
        throw new Error("blockchainError");
    }
    return components
        .slice()
        .sort((0, utils_1.comparator)(sortBy))
        .map(item => {
        let tokenId;
        if (item?.contract?.contractType === types_1.TokenType.NATIVE || item?.contract?.contractType === types_1.TokenType.ERC20) {
            tokenId = "0";
        }
        else if (item?.contract?.contractType === types_1.TokenType.ERC721 ||
            item?.contract?.contractType === types_1.TokenType.ERC998) {
            tokenId = (item.tokenId || 0).toString();
        }
        else if (item?.contract?.contractType === types_1.TokenType.ERC1155) {
            tokenId = item.template?.tokens?.[0]?.tokenId || item.token?.tokenId;
            if (!tokenId) {
                // tokenId for ERC1155 notFound. You most likely forget to leftAndJoin Tokens for ERC1155
                throw new Error("blockchainError");
            }
        }
        else {
            throw new Error("blockchainError");
        }
        const [whole = "", decimals = ""] = multiplier.toString().split(".");
        const amount = ((BigInt(item.amount) * BigInt(`${whole}${decimals}`)) /
            10n ** BigInt(decimals.length)).toString();
        return {
            tokenType: Object.values(types_1.TokenType).indexOf(item.tokenType),
            token: item.contract.address,
            tokenId,
            amount,
        };
    });
};
exports.convertDatabaseAssetTokenIdToChainAsset = convertDatabaseAssetTokenIdToChainAsset;
// Same as convertDatabaseAssetToChainAsset
// But return tokenType: TokenType
const convertDatabaseAssetToTokenTypeAsset = (components, options = {}) => {
    const assets = !options.deposit
        ? (0, exports.convertDatabaseAssetTokenIdToChainAsset)(components, options)
        : (0, exports.convertDatabaseAssetToChainAsset)(components, options);
    return assets.map(asset => {
        return {
            ...asset,
            tokenType: Object.values(types_1.TokenType)[asset.tokenType],
        };
    });
};
exports.convertDatabaseAssetToTokenTypeAsset = convertDatabaseAssetToTokenTypeAsset;
const convertTemplateToChainAsset = (template, amount = "1") => {
    let tokenId;
    if (template === undefined) {
        throw new Error("blockchainError");
    }
    if (template?.contract?.contractType === types_1.TokenType.NATIVE || template?.contract?.contractType === types_1.TokenType.ERC20) {
        tokenId = "0";
    }
    else if (template?.contract?.contractType === types_1.TokenType.ERC721 ||
        template?.contract?.contractType === types_1.TokenType.ERC998) {
        tokenId = (template.id || 0).toString();
    }
    else if (template?.contract?.contractType === types_1.TokenType.ERC1155) {
        tokenId = template?.tokens?.[0]?.tokenId;
        if (!tokenId) {
            // tokenId for ERC1155 notFound. You most likely forget to leftAndJoin Tokens for ERC1155
            throw new Error();
        }
    }
    else {
        throw new Error("blockchainError");
    }
    return {
        tokenType: Object.values(types_1.TokenType).indexOf(template.contract.contractType),
        token: template.contract.address,
        tokenId,
        amount,
    };
};
exports.convertTemplateToChainAsset = convertTemplateToChainAsset;
const convertTemplateToTokenTypeAsset = (template, amount) => {
    const asset = (0, exports.convertTemplateToChainAsset)(template, amount);
    return {
        ...asset,
        tokenType: Object.values(types_1.TokenType)[asset.tokenType],
    };
};
exports.convertTemplateToTokenTypeAsset = convertTemplateToTokenTypeAsset;
//# sourceMappingURL=asset.js.map